import { Component, OnInit, Input } from '@angular/core';
import { IssueOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';


@Component({
  selector: 'app-issue-preview',
  templateUrl: './issue-preview.component.html',
  styleUrls: ['./issue-preview.component.css']
})
export class IssuePreviewComponent implements OnInit {

  _issue: IssueOverviewModel;
  @Input() set issue(issue: IssueOverviewModel){
    this._issue = issue;
    if(issue){
      if(issue.customer) this.subTitles.push({ value: issue.customer, type: "Kunde" });
      if(issue.category) this.subTitles.push({ value: issue.category, type: "Kategorie" });
      if(issue.state) this.subTitles.push({ value: issue.state, type: "Status" });
      if(issue.laststatuschange) this.subTitles.push({ value: moment(issue.laststatuschange).locale('de').format("DD.MM.YYYY HH") + " Uhr", type: "Änd. Status" });
      if(issue.issueescalation) this.subTitles.push({ value: moment(issue.issueescalation).locale('de').format("DD.MM.YYYY HH") + " Uhr", type: "Wunschdatum" });
    }
  }
  get issue(): IssueOverviewModel {
    return this._issue;
  }

  subTitles: SubTitleWrapper[] = [];

  constructor() {

  }

  ngOnInit(): void {
  }


}
